import { render, staticRenderFns } from "./EditStockArea.vue?vue&type=template&id=30950318&"
import script from "./EditStockArea.vue?vue&type=script&lang=js&"
export * from "./EditStockArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports